import Enum from 'enum';

const purchaseOrderLineStatus = new Enum(
  {
    NotSubmitted: 'New',
    ImagesUploaded: 'Pending',
    UnderReview: 'Submitted',
    NotApproved: 'Rejected',
    Approved: 'Approved',
    Commented: 'Commented',
  },
  {
    name: 'PurchaseOrderLineStatus',
    freez: true,
    ignoreCase: true,
  },
);

export default purchaseOrderLineStatus;
